var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDotLetter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 53,
    viewBox: "0 0 48 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9685 52.2187C37.1294 52.2187 47.7984 40.5479 47.7984 26.1511C47.7984 11.7544 37.1294 0.0834961 23.9685 0.0834961C10.8077 0.0834961 0.138672 11.7544 0.138672 26.1511C0.138672 40.5479 10.8077 52.2187 23.9685 52.2187Z",
    fill: "#FEBF88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotLetter);
export default __webpack_public_path__ + "static/media/dot-letter.d17c1fda44955b75453faad5282f25c6.svg";
export { ForwardRef as ReactComponent };